export enum QuestionFeedbackCommentType {
  FalseInformation = "falseInformation",
  Incomprehensible = "incomprehensible",
  PoorHint = "poorHint",
  PoorEvaluation = "poorEvaluation",
  Irrelevant = "irrelevant",
  TooEasy = "tooEasy",
  TooHard = "tooHard",
  TooLong = "tooLong",
  TooShort = "tooShort",
}

export enum MessageFeedbackCommentType {
  FalseInformation = "falseInformation",
  Incomprehensible = "incomprehensible",
  Irrelevant = "irrelevant",
  TooLong = "tooLong",
  TooShort = "tooShort",
}
